import { AnyARecord } from "node:dns";

export const SET_MEAL_DATA = 'SET_MEAL_DATA';
export const SET_MEAL_CUSTOMIZE_DATA = 'SET_MEAL_CUSTOMIZE_DATA';
export const CLEAR_MEAL_DATA = 'CLEAR_MEAL_DATA';
export const CLEAR_MEAL_CUSTOMIZE_DATA = 'CLEAR_MEAL_CUSTOMIZE_DATA';
export const SELECTED_MEAL_ITEM='SELECTED_MEAL_ITEM';
export const SELECTED_MEAL_ITEM_DATA="SELECTED_MEAL_ITEM_DATA"



export const SETCHANGE_SELECTMEALITEM1=(data:any)=>{
    return {
        type:SELECTED_MEAL_ITEM,
        payload:data
    }
}

export const SETCHANGE_SELECTMEALITEM2=(data:any)=>{
    return {
        type:SELECTED_MEAL_ITEM_DATA,
        payload:data
    }
}

export const SETMEALDATA = (data: any) => {
    return {
        type: SET_MEAL_DATA,
        payload: data
    }
}
export const SETMEALCUSTOMIZEDATA = (data: any) => {
    return {
        type: SET_MEAL_CUSTOMIZE_DATA,
        payload: data
    }
}
export const CLEARMEALDATA = () => {
    return {
        type: CLEAR_MEAL_DATA,
        payload: ''
    }
}

export const CLEARMEALCUSTOMIZEDATA = () => {
    return {
        type: CLEAR_MEAL_CUSTOMIZE_DATA,
        payload: ''
    }
}


const initialState: any = {
    mealData: {},
    mealCustomizeData: {},
    selectMealItem1:{},
    selectMealItemdata2:{}
}

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case SET_MEAL_DATA:
            return {
                ...state,
                mealData: payload
            };
        case SET_MEAL_CUSTOMIZE_DATA:
            return {
                ...state,
                mealCustomizeData: payload
            };
        case CLEAR_MEAL_DATA:
            return {
                mealData: {},
                mealCustomizeData: {},
                selectMealItem1:{},
                selectMealItemdata2:{}
            };
        case CLEAR_MEAL_CUSTOMIZE_DATA:
            return {
                ...state,
                mealCustomizeData: {}
            }
        case SELECTED_MEAL_ITEM :
            return {
                ...state,
                selectMealItem1:payload
            }
        case SELECTED_MEAL_ITEM_DATA:
            return {
                ...state,
                selectMealItemdata2:payload
            }
        default:
            return state
    }
}
export default reducer;